<template>
  <div class="news-box">
    <div class="news-box-bg">
       <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>高考资讯</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <el-row class="news-box-list">
      <el-col :span="16">
        <div class="no-data-box" v-if="showDataStr=='2' && tabList.length === 0">
          <img src="../../assets/images/null.png" alt="没有数据">
          <p>暂无数据</p>
      </div>
        <template v-else>
          <el-tabs class="school-detail-nav" @tab-click="changeSchoolNewsHandler">
            <el-tab-pane :label="item.cate_name" v-for="(item,index) in tabList" :key="index">
              <el-row class="news-box-content">
                <div v-if="showDataStr == '1'">
                  <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1000" viewBox="0 0 1000 200" v-for="item in 10" :key="item">
                    <rect x="0" y="0" width="250" height="170" />
                    <rect x="270" y="5" width="600" height="30" />
                    <rect x="270" y="50" width="200" height="30" />
                  </ContentLoader>
                </div>
                <div class="no-data-box" v-else-if="showDataStr=='2'">
                    <img src="../../assets/images/null.png" alt="没有数据">
                    <p>暂无数据</p>
                </div>
                <el-row  v-else-if="showDataStr=='3'" type="flex" justify="space-between" class="news-list" v-for="(item1,index1) in newsList" :key="index1" @click.native="goDetailHandler(item1.id)">
                  <el-col :span="23">
                    <el-col :span="7">
                      <div class="news-box-img">
                        <el-image :src="item1.banner_url" alt="高考热门咨询" fit="cover"></el-image>
                      </div>
                    </el-col>
                    <el-col :span="16" class="news-text">
                      <h3>{{item1.news_title}}</h3>
                      <p v-if="item1.tag_name">{{item1.tag_name}}</p>
                      <div class="news-date">{{item1.create_time|formatDate}}<span>{{item1.browse_count}}次浏览量</span></div>
                    </el-col>
                  </el-col>
                </el-row>
              </el-row>
              <el-pagination
                    background
                    layout="prev, pager, next, jumper"
                    :total="totalData" :page-size="10" @current-change="schoolNewsHandler" :current-page.sync="currentPage" v-if="showDataStr=='3'">
                </el-pagination>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-col>
      <el-col :span="8" style="margin-top:80px;;padding-left: 10px">
        <News class="news-right"></News>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { newsCate, newsList } from '@/api/news'
import { ContentLoader } from 'vue-content-loader'
export default {
  components: {
    ContentLoader
  },
  data() {
    return {
      tabList: [],
      newsList: [],
      totalData: 0,
      activeIndex: 0,
      currentPage: 1,
      showDataStr: '1',
    }
  },
  filters: {
    formatDate: function(time) {
      time = time * 1000
      let date = new Date(time);
      let YY = date.getFullYear();
      let MM = date.getMonth() + 1;
      let DD = date.getDate();
      return YY + '.' + MM + '.' + DD;
    }
  },
  created() {
    this.$store.commit('user/ADDCOUNT', 0);
    this.schoolNewsCateHandler();
  },
  methods: {
    changeSchoolNewsHandler(e) {
      this.activeIndex = e.index;
      this.currentPage = 1;
      this.totalData = 0;
      this.newsList = [];
      this.showDataStr = '1';
      this.schoolNewsHandler('1');
    },
    schoolNewsCateHandler() {
      newsCate(localStorage.getItem("area")).then(res => {
        if(res.data.length === 0) {
          this.showDataStr = '2';
          return
        }
        this.tabList = [...res.data];
        this.schoolNewsHandler('1');
      })
    },
    schoolNewsHandler(page) {
      let cate_id = this.tabList[this.activeIndex].id;
      newsList(page, cate_id, 10, localStorage.getItem("area")).then(res => {
        if(res.data.count == 0) {
          this.showDataStr = '2';
          return
        }
        this.showDataStr = '3';
        const newsList = res.data.data.map(item => {
            if(!item.banner_url) {
              let index = Math.random();
              index = index * 10;
              index = Math.ceil(index); 
              item.banner_url = require('../../assets/images/news'+ index + '.png');
          } else {
              item.banner_url = 'https://gaokao.zmpajx.com/' + item.banner_url;
          }
            return item;
        })
        this.newsList = [...newsList];
        this.totalData = res.data.count;
      })
    },
    goDetailHandler(id) {
      this.$router.push({
				path:'/newsDetail',
          query: {
              id: id
          }
			})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/css/variables.scss";
  // .news-box {
  //     @include gwidth;
  // }
  .news-box-bg {
    background: url("../../assets/images/news-bg.png") no-repeat;
    background-size: cover;
    background-position: center;
    height: 132px;
  }
  .zy-img {
    height: 120px;
    margin-top: 10px;
  }
  .news-box-list {
    border: none;
    box-shadow: none!important;
    margin-top: 24px;
    @include gwidth;
    margin-top:-46px;
  }
  .news-box-content {
    .news-list {
      height: 140px;
      margin-bottom: 32px;
      cursor: default;
      position: relative;
    }
    .news-list:hover {
      h3 {
        color: $common-color;
      }
      img {
        -webkit-transform: scale(1.1);
        -moz-transform: scale(1.1);
        -ms-transform: scale(1.1);
        transition:all 0.5s;
        -webkit-transition:all 0.5s;
        -ms-transition:all 0.5s;
      }
    }
    .news-box-img {
      width: 200px;
      height: 140px;
      border-radius: 4px;
      background: transparent;
      overflow: hidden;
    }
    img {
      width: 200px;
      height: 140px;
      border-radius: 4px;
    }
    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #2c2e33;
      margin: 0;
      @include gnowrap;
      margin-top: 4px;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      color: #5e6166;
      margin-top: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .news-date {
      font-size: 14px;
      color: #909399;
      position: absolute;
      margin-top: 20px;
      span {
        margin-left: 24px;
      }
    }
  }
  .news-right {
    box-shadow: none;
    background: #ffffff;
    border: 1px solid #f5f7fa;
    border-radius: 10px;
  }
  .no-data-box {
    position: relative;
    top: 230px;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
        margin-left: -14px;
    }
  }
</style>